/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Ladda from 'ladda';
import { View } from 'backbone.marionette';

import tmplConfirmationModalView from './ConfirmationModalView.hbs';

const ConfirmationModalView = View.extend({
  template: tmplConfirmationModalView,

  ui: {
    btnNo: '.btn-no',
    btnYes: '.btn-yes'
  },

  events: {
    'click @ui.btnNo': 'onClickNo',
    'click @ui.btnYes': 'onClickYes'
  },

  options: {
    rejectButtonClass: 'btn-default',
    confirmButtonClass: 'btn-danger',
    rejectText: 'Cancel',
    confirmText: 'Yes'
  },

  templateContext() {
    const { rejectButtonClass, confirmButtonClass, rejectText, confirmText } = this.options;
    return {
      rejectButtonClass,
      confirmButtonClass,
      rejectText,
      confirmText
    };
  },

  onClickNo(e) {
    e.preventDefault();
    this.triggerMethod('modal:close', false);
  },

  onClickYes(e) {
    e.preventDefault();
    const onConfirm = this.model.get('onConfirm');
    if (onConfirm && _.isFunction(onConfirm)) {
      const spinner = Ladda.create(this.ui.btnYes.get(0));
      spinner.start();
      onConfirm()
        .then(() => {
          const onConfirmDone = this.model.get('onConfirmDone');
          if (onConfirmDone && _.isFunction(onConfirmDone)) {
            onConfirmDone(e);
          }
          this.triggerMethod('modal:close', true);
        })
        .catch(() => {
          const onConfirmFail = this.model.get('onConfirmFail');
          if (onConfirmFail && _.isFunction(onConfirmFail)) {
            onConfirmFail(e);
          }
          this.triggerMethod('modal:close', true);
        });
    } else {
      this.triggerMethod('modal:close', true);
    }
  }
});

export default ConfirmationModalView;
